import React from "react";
import { Modal } from "@mui/material";
import "./index.css";
import MemberCardList from "./MemberCardList";

interface IProps {
  isOpen?: boolean;
  setIsOpen: any;
}
const MemberCardAction: React.FC<IProps> = ({ isOpen, setIsOpen }) => {
  return (
    <Modal
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      style={{
        background: "#111111",
        border: "1px solid #333",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "275px",
        height: "375px",
        margin: "auto",
        padding: "20px 20px 0px 20px",
        borderRadius: "10px",
        color: "white",
      }}
    >
      <MemberCardList/>
    </Modal>
  );
};

export default MemberCardAction;
